import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor(private httpClient: HttpClient) {}

  get(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${environment.backendUrl}/api/v1/currencies/allowed`);
  }
}
